import BaseModel from './BaseModel';

class Offer extends BaseModel {
  constructor(data = {}, condition) {
    super(data);
    switch (condition) {
      case 1:
        this.setApiData(data);
        break;
      case 2:
        this.setUniversalOfferData(data);
        break
      case 3:
        this.updateData(data);
        break;
      default:
        this.updateData(data);
        break;
    }
  }

  setUniversalOfferData = (data) => {
    this.branches = data.branches || [];
    this.branch_ids = data.branches.map((branch) => branch.id) || [];
    this.fleet_owners = data.fleet_owners || [];
    this.fleet_owner_ids = data.fleet_owners.map((fleet_owner) => fleet_owner.id);
    this.security_amount = data.security_amount_display || {};
    this.product_id = data.product.id || "";
    if(this.security_amount){
      this.security_amount_id = data.security_amount_display.id || "";
    }
    this.user_type = data.user_type || "";
    this.rfid_types = data.rfid_types || [];
    this.rfid_type_ids = data.rfid_types.map((rfid_type) => rfid_type.id);
    this.vehicle_type = data.vehicle_type || {};
    if(data.vehicle_type) {
      this.vehicle_type_id = data.vehicle_type.id || "";
    }
    // if (data.offer_swap_count_amount) {
    //   this.offer_swap_count_amount = data.offer_swap_count_amount.map((swap_config_item, index) => {
    //     if(this.id == undefined || this.id == null) {
    //       return { ...swap_config_item, key: index, id: null }
    //     }
    //   });
    // }
    this.deleted_configs = [];
    this.disable_offer_type = data.disable_offer_type
  }

  setApiData = (data) => {
    this.id = data.id;
    this.offer_name = data.offer_name ? parseInt(data.offer_name): "";
    this.universal_offer = data.universal_offer || {};
    this.name = data.name;
    this.disable_offer_type = true;
    this.offer_type_id = data.offer_type.id || "2";
    this.customer_validity_limit = data.customer_validity_limit || "";
    this.scheme = data.scheme || {};
    this.scheme_id = data.scheme.id || "";
    this.branches = data.branches || [];
    this.branch_ids = data.branches.map((branch) => branch.id) || [];
    this.fleet_owners = data.fleet_owners || [];
    this.fleet_owner_ids = data.fleet_owners.map((fleet_owner) => fleet_owner.id);
    this.security_amount = data.security_amount_display || {};
    if(this.security_amount){
      this.security_amount_id = data.security_amount_display.id || "";
    }
    this.user_type = data.user_type || "";
    this.rfid_types = data.rfid_types || [];
    this.rfid_type_ids = data.rfid_types.map((rfid_type) => rfid_type.id);
    this.vehicle_type = data.vehicle_type || {};
    if(data.vehicle_type) {
      this.vehicle_type_id = data.vehicle_type.id || "";
    }
    this.vehicle_type_id = data.vehicle_type.id || "";
    this.branch_offer_configs = data.branch_offer_configs || [];
    if(data.branch_offer_configs){
      // create configs for the branches whose configs are not already created for the form.
      // if config is not provided then make a default config with a distant date and amount 0.
      let config_created_branches = []
      this.branch_offer_configs = data.branch_offer_configs.map((branch_offer_config)=> {
        config_created_branches.push(branch_offer_config.branch_id);
        if(branch_offer_config.config.constructor === Object && Object.keys(branch_offer_config.config).length === 0) {
          return  {
            id: branch_offer_config.id,
            branch_id: branch_offer_config.branch_id,
            config: {
              ...branch_offer_config.config,
              present_cashback: {amount: 0, start_date: new Date(), end_date: new Date("December 31, 2030")},
              absent_penalty: {amount: 0, start_date: new Date(), end_date: new Date("December 31, 2030")}
            }
          }
        } else {
          return {...branch_offer_config}
        }
      });

      let left_out_branches = this.branch_ids.filter((branch_id)=> !(this.branch_ids && config_created_branches).includes(branch_id))
      let left_out_branch_configs = left_out_branches.map((left_out_branch)=> {
        return {
            branch_id: left_out_branch,
            config: {
              ...left_out_branch.config,
              present_cashback: {amount: 0, start_date: new Date(), end_date: new Date("December 31, 2030")},
              absent_penalty: {amount: 0, start_date: new Date(), end_date: new Date("December 31, 2030")}
            }
          }
      })
      this.branch_offer_configs = this.branch_offer_configs.concat(left_out_branch_configs)
    }

    if (data.offer_swap_count_amount) {
      this.offer_swap_count_amount = data.offer_swap_count_amount.map((swap_config_item, index) => {
        return { ...swap_config_item, key: index }
      });
    }
    this.deleted_configs = [];
    if (data.product) {
      this.product_id = data.product?.id;
    }
  }

  updateData = (data) => {
    this.id = data.id;
    this.universal_offer = this.universal_offer || {};
    this.offer_name = data.offer_name || "";
    this.name = data.name || "";
    this.offer_type_id = data.offer_type_id || "";
    this.customer_validity_limit = data.customer_validity_limit || "";
    this.scheme = data.scheme || {};
    this.scheme_id = data.scheme_id || "";
    this.branches = data.branches || [];
    this.branch_ids = data.branch_ids || [];
    this.fleet_owners = data.fleet_owners;
    this.fleet_owner_ids = data.fleet_owner_ids || [];
    this.security_amount = data.security_amount;
    this.security_amount_id = data.security_amount_id || "";
    this.user_type = data.user_type || "";
    this.rfid_types = data.rfid_types;
    this.rfid_type_ids = data.rfid_type_ids || [];
    this.vehicle_type = data.vehicle_type;
    this.vehicle_type_id = data.vehicle_type_id || "";
    if (data.offer_swap_count_amount) {
      this.offer_swap_count_amount = data.offer_swap_count_amount.map((swap_config_item, index) => {
        return { ...swap_config_item, key: index }
      });
    } else {
      this.offer_swap_count_amount = [{
        key: 0,
        swap_count_for_day: "",
        amount: ""
      }]
    }
    this.branch_offer_configs = data.branch_offer_configs || [];
    this.deleted_configs = data.deleted_configs || [];
    this.disable_offer_type = data.disable_offer_type;
    this.product_id = data.product_id || "";
  }

  toApiJson = () => {
    this.completeValidation();
    return {
      id: this.id,
      offer: {
        name: this.name,
        offer_type_id: this.offer_type_id,
        customer_validity_limit: this.customer_validity_limit,
        offer_name: this.offer_name,
        scheme_id: this.scheme_id,
        branch_ids: this.branch_ids,
        fleet_owner_id: this.fleet_owner_ids,
        security_amount_display_id: this.security_amount_id,
        user_type: this.user_type,
        rfid_type_id: this.rfid_type_ids,
        vehicle_type_id: this.vehicle_type_id,
        offer_swap_count_amounts_attributes: this.offer_swap_count_amount.concat(this.deleted_configs),
        branch_offer_configs_attributes: this.branch_offer_configs,
        product_id: this.product_id
      }
    }
  }

  validations = (field) => {
    return {
      name: () => {
        if (this[field] === "") {
          this.errors.name = "This field is required and cannot be empty.";
        } else {
          delete this.errors.name
        }
      },
      offer_type_id: () => {
        if (this[field] === "") {
          this.errors.offer_type_id = "This field is required and cannot be empty.";
        } else {
          delete this.errors.offer_type_id;
        }
      },
      customer_validity_limit: () => {
        if (this[field] === "") {
          this.errors.customer_validity_limit = "This field is required and cannot be a negative number.";
        } else {
          delete this.errors.customer_validity_limit;
        }
      },
      scheme_id: () => {
        if (this[field] === "") {
          this.errors.scheme_id = "This field is required and cannot be a empty.";
        } else {
          delete this.errors.scheme_id;
        }
      },
      branch_ids: () => {
        if(this[field].length === 0) {
          this.errors.branch_ids = "This field is required and cannot be a empty.";
        } else {
          delete this.errors.branch_ids;
        }
      },
      security_amount_id : () => {
        if (this[field] === "") {
          this.errors.security_amount_id = "This field is required and cannot be a empty.";
        } else {
          delete this.errors.security_amount_id;
        }
      },
      user_type: () => {
        if (this[field] === "") {
          this.errors.user_type = "This field is required.";
        } else {
          delete this.errors.user_type;
        }
      },
      rfid_type_ids: () => {
        if (this[field].length === 0) {
          this.errors.rfid_type_ids = "This field is required.";
        } else {
          delete this.errors.rfid_type_ids;
        } 
      },
      vehicle_type_id: () => {
        if (this[field] === "") {
          this.errors.vehicle_type_id = "This field is required.";
        } else {
          delete this.errors.vehicle_type_id;
        } 
      },
      absent_penalty_amount: () => {
        if (this[field].trim() === "" && (this.absent_penalty_start_date !== "" || this.absent_penalty_end_date !== "")) {
          this.errors.absent_penalty_amount = "This field is required.";
        } else if(this[field] < 0) {
          this.errors.absent_penalty_amount = "Amount must be a positive number.";
        } else {
          delete this.errors.absent_penalty_amount;
        }
      },
      absent_penalty_start_date: () => {
        if(this[field] === "" && (this.absent_penalty_amount !== "" || this.absent_penalty_end_date !== "")) {
          this.errors.absent_penalty_start_date = "This field is required.";
        } else if(this.absent_penalty_end_date && this[field] > this.absent_penalty_end_date){
          this.errors.absent_penalty_start_date = "Start Date must be smaller than end date";
        } else {
          delete this.errors.absent_penalty_start_date;
        }
      },
      absent_penalty_end_date: () => {
        if(this[field] === "" && (this.absent_penalty_amount !== "" || this.absent_penalty_start_date !== "")) {
          this.errors.absent_penalty_end_date = "This field is required.";
        } else if(this.absent_penalty_start_date && this[field] < this.absent_penalty_start_date) {
          this.errors.absent_penalty_end_date = "End Date must be greater than start date";
        } else {
          delete this.errors.absent_penalty_end_date;
        }
      },
      present_cashback_amount: () => {
        if (this[field].trim() === "" && (this.present_cashback_start_date !== "" || this.present_cashback_end_date !== "")) {
          this.errors.present_cashback_amount = "This field is required.";
        } else if(this[field] < 0) {
          this.errors.present_cashback_amount = "Amount must be a positive number.";
        } else {
          delete this.errors.present_cashback_amount;
        }
      },
      present_cashback_start_date: () => {
        if(this[field] === "" && (this.present_cashback_amount !== "" || this.present_cashback_end_date !== "")) {
          this.errors.present_cashback_start_date = "This field is required.";
        } else if(this.present_cashback_end_date && this[field] > this.present_cashback_end_date){
          this.errors.present_cashback_start_date = "Start Date must be smaller than end date";
        } else {
          delete this.errors.present_cashback_start_date;
        }
      },
      present_cashback_end_date: () => {
        if(this[field] === "" && (this.present_cashback_start_date !== "" || this.present_cashback_amount !== "")) {
          this.errors.present_cashback_end_date = "This field is required.";
        } else if(this.present_cashback_start_date && this[field] < this.present_cashback_start_date) {
          this.errors.present_cashback_end_date = "End Date must be greater than start date";
        } else {
          delete this.errors.present_cashback_end_date;
        }
      },
      product_id: () => {
        if(this[field] === "") {
          this.errors.product_id = "This field is required.";
        } else {
          delete this.errors.product_id;
        }
      },
      branch_offer_configs: () => {
        if (
          this[field] &&
          Array.isArray(this[field]) &&
          this[field].length > 0 &&
          this[field]
            .map(branch_config => 
              Array.isArray(branch_config.config.merchant_configs) && 
              branch_config.config.merchant_configs.some(
                merchant_config =>
                  merchant_config.id === '' ||
                  merchant_config.recharge_cashback_percentage === '' ||
                  merchant_config.recharge_amount_threshold === ''
              )
            )
            .includes(true)
        ) {
          this.errors.branch_offer_configs =
            'Please fill all fields in the Merchant Cashback Configuration.';
        } else {
          delete this.errors.branch_offer_configs;
        }
      }
      // swap_count_for_day: () => {
      //   if (this[field] === "") {
      //     this.errors.swap_count_for_day = "This field is required.";
      //   } else {
      //     delete this.errors.swap_count_for_day;
      //   }
      // },
      // amount: () => {
      //   if (!this[field] || isNaN(this[field]) || parseFloat(this[field]) < 0) {
      //     this.errors.amount = "Amount should be a positive number.";
      //   } else {
      //     delete this.errors.amount;
      //   }
      // },
     
    }[field];
  }

  validate = (field) => {
    if (this.validations(field)) {
      this.validations(field)()
    }
  }
}

export default Offer
